import {DragEndEvent} from '@dnd-kit/core';

import {EagColumnState} from '../types/EagColumnState';

type UseColumnDragReturn = {
  handleDragEnd: (event: DragEndEvent) => void;
  sortableIds: string[];
};

export const useColumnDrag = (
  visibleColumnStates: EagColumnState[],
  reorderByKey: (fromKey: string, toKey: string) => void
): UseColumnDragReturn => {
  const sortableIds = visibleColumnStates.map((cs) => cs.key);

  const handleDragEnd = (event: DragEndEvent) => {
    if (!event.over || event.active.id === event.over.id) {
      return;
    }
    reorderByKey(String(event.active.id), String(event.over.id));
  };

  return {handleDragEnd, sortableIds};
};
